<!-- eslint-disable vue/multi-word-component-names -->
<script setup lang="ts">
import { onMounted } from 'vue'
import { useRouter } from 'vue-router'
import { useGameStore } from '@/stores/gameStore.ts'

/**
 * Stores / models
 */
const gameStore = useGameStore()
const router = useRouter()

/**
 * Lifecycle hooks
 */
onMounted(() => {
  router.push('/map/galaxy')
})
</script>

<template>

</template>

<style scoped lang="scss"></style>
